var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['action-button', { 'action-button--remove-margin': _vm.removeMargin }],style:(_vm.style),on:{"click":_vm.gotToAction_ClickHandler}},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d8a4dd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ui/ActionButton.vue
// module id = null
// module chunks = 